import React, { useState } from "react";
import "../../Registration/MainRegister/mainRegister.css";
import { Link } from "react-router-dom";
import "../LoginWithMPIN/loginWithMPIN.css";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";
import axios from "../../../axios";
import NotRegisterPopUp from "../NotRegisterNotify/NotRegisterPopUp";
import ForgotPassWordVerify from "../ForgotPassWord/ForgotPassWordVerify";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setUserInformation,
  setSchoolId,
} from "../../../redux/initialDataSlice";

export default function LoginWithPassWord() {
  const navigate = useNavigate();
  // change the state name because avoid duplicate name
  const dispatch = useDispatch();
  const [userLogin, setUserLoginVarify] = useState({
    userId: "",
    Password: "",
    verifyUser: false,
  });
  const [validPassW, setValidPassW] = useState();
  const School_ID = JSON.parse(localStorage.getItem("School_id"));
  const uname = JSON.parse(localStorage.getItem("UserName"));
  const schoolCode = localStorage.getItem("schoolCodeForTeacher");

  const [popup, setPopup] = useState();

  function myFunction() {
    var x = document.getElementById("input_login");
    var y = document.getElementById("close_eye");
    var Z = document.getElementById("open_eye");

    if (x.type === "password") {
      x.type = "text";
      y.style.display = "none";
      Z.style.direction = "block";
    } else {
      x.type = "password";
      y.style.display = "block";
      Z.style.direction = "none";
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    let UserloginPassWord = {
      user_id: School_ID,
      password: userLogin.Password,
      school_code: schoolCode,
    };

    try {
      const res = await axios.post(
        `/api/v1/teacherAuth/loginWithPassword`,
        UserloginPassWord,
      );
      localStorage.setItem("Header", "Digital Class Management");
      res && setUserLoginVarify(true);
      if (res) {
        localStorage.setItem(
          "AuthToken",
          JSON.stringify(res.data?.data?.accessToken),
        );
        localStorage.setItem(
          "features",
          JSON.stringify(res.data?.data?.features),
        );
        localStorage.setItem("UserInformation", JSON.stringify(res.data.data));
        dispatch(setUserInformation(res?.data?.data));
        dispatch(setSchoolId(res.data.data.school?.id));
        const schoolId = res?.data?.data?.school.id;
        localStorage.setItem("schoolId", JSON.stringify(schoolId));

        navigate("/loginSuccess", { state: { loginRes: res?.data?.data } });
      }
    } catch (error) {
      console.log(error);
      setValidPassW(error.response.data);
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    let loginMpinUser = {
      school_assigned_id: School_ID,
      school_code: schoolCode,
    };

    try {
      const res = await axios.post(
        `/api/v1/teacherAuth/validateShoolAssignedId`,
        loginMpinUser,
      );
      res.data.status === "Not-Registered" && setPopup(true);

      res.data.status === "Registered" &&
        setUserLoginVarify({
          ...userLogin,
          verifyUser: true,
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    userLogin.Password === "" && setValidPassW("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogin.Password]);

  return (
    <div className="TotalContainer  d-md-flex m-0">
      {/* <div className='MainContainer col-12 p-0 '> */}

      <div className="banner_box col-lg-3 col-md-5  p-0 m-0 col-12">
        <img
          className="banner_img "
          src="/Register-img/baner_img.jpg"
          alt="banner img"
        ></img>
      </div>

      <div className="form_box_loin  col-lg-9 col-md-7  col-12 p-0 ">
        <div>
          <form>
            <div className="total_logo_regist">
              <img
                className="logo_registration"
                src="/Register-img/Register_logo.png"
                alt="register logo"
              ></img>
            </div>
            <div className="title_regis">Welcome {uname}</div>
            <div className="login_mpin">Login with Password</div>

            <div className="input_box2">
              <div type="text" className="school_id_mpin" placeholder="User ID">
                {School_ID}
              </div>
            </div>

            <div className="input_box2 ">
              <input
                id="input_login"
                type="password"
                placeholder="Enter Password"
                onChange={(e) =>
                  setUserLoginVarify({
                    ...userLogin,
                    Password: e.target.value,
                  })
                }
                minLength={8}
                maxLength={64}
                autocomplete="off"
              ></input>
              <span onClick={myFunction} className="Eye_login">
                <IoEyeOffOutline id="close_eye" />
                <IoEyeOutline id="open_eye" />
              </span>
            </div>
            {validPassW?.status === false && (
              <div className="invailidOtp">Invalid Password entered</div>
            )}
            <div>
              <button
                class="btn btn"
                id={!userLogin.Password ? "btn_disabled" : "main_login_btn"}
                disabled={!userLogin.Password}
                type="submit"
                onClick={handleSubmit}
              >
                Login
              </button>
            </div>

            <div className="forgot_MPIN" onClick={handleForgot}>
              Forgot Password?
            </div>

            <div className="or_line">Or</div>
            <div>
              <Link to="/LoginWithMpin">
                <button class="btn btn" id="Login_with_pass_Btn" type="button">
                  Login with Pin
                </button>
              </Link>
            </div>
            {/* Hide option for login with OTP */}
            {/* <div >
                            <Link to='/LoginWithOTP'><button class="btn btn" id='Login_with_pass_Btn' type="button">Login with OTP</button></Link>
                        </div> */}
            <div className="total_already_login">
              <span className="not_john">Not {uname}?</span>&nbsp;
              <Link className="Link_register" to="/">
                <span className="login_diff_ccount">
                  Login with different account
                </span>
              </Link>
            </div>
            {/* </div> */}
          </form>
        </div>
      </div>
      {popup && <NotRegisterPopUp setPopup={setPopup} />}
      {userLogin.verifyUser && (
        <ForgotPassWordVerify setUserLoginVarify={setUserLoginVarify} />
      )}
    </div>
  );
}
